import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

export const SendingReportAfterShiftClosingField: React.FC = () => {
	const { report } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = report?.isShiftsWorking;
	const inputValue = isChecked ? t('yes') : t('no');

	return (
		<FullInfoField
			label="sendingReportAfterShiftLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
